import React,{useState, useContext, useRef, useEffect} from 'react'
import { GlobalContext } from '../../../context/provider';
import { MdDone, MdOutlineClose, MdKeyboardArrowDown, MdSearch, MdDeleteForever } from "react-icons/md";
import numberbeautify from "../../../utils/numberbeautify";
import customerloanreportaction from '../../../context/action/report/customerloanreportaction';
import Customer_loan_table from './customer_loan_table';
import customerloaninreportaction from '../../../context/action/report/customerloaninreportaction';
import Loan_in_table from './loan_in_table';
import summaryloaninreportaction from '../../../context/action/report/summaryloaninreportaction';
import Summary_loan_in_table from './summary_loan_in_table';

const Customer_Loan_Report = () => {
  const { initState, initDispatch, clear } = useContext(GlobalContext);

  const dropdownRef = useRef(null);
          
  const [from, setfrom] = useState("");
  const [to, setto] = useState("");
  const [table_type, settable_type] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [customer, setcustomer] = useState(initState?.customer);
  const [customer_id, setcustomer_id] = useState();
  const [searchTerm, setSearchTerm] = useState("");

  const [error, seterror] = useState(false);
  const [error1, seterror1] = useState(false);

  const filtereddoctor = customer.filter(option =>
      option.customer_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handlePresetClick = (option) => {
      setcustomer_id(option?.customer_id);
      setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
            // setitem_suggestion([]);
        }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  return (
    <div className="min-h-screen bg-slate-50 p-6 md:p-8">
        {/* Page Header */}
        <div className="flex items-center justify-between mb-8">
            <div>
            <h1 className="text-2xl font-bold text-slate-800">ڕاپۆرت ← کڕیار</h1>
            <p className="text-sm text-slate-400 mt-0.5">داتا و وردەکاری کڕیارەکان</p>
            </div>
        </div>

        {/* Add New Category Form */}
        <div className="bg-white border border-slate-100 rounded-xl p-6 mb-6 shadow-sm">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 items-end">
                <div className="relative w-full" ref={dropdownRef}>
                    <label
                        className="block text-sm font-medium text-slate-500 mb-1 text-right"
                    >
                        کڕیار
                    </label>
                    <div 
                        className="w-full flex justify-between items-center h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                        onClick={() => {setIsOpen(!isOpen);}}
                        title={customer_id && customer_id!=0 ?numberbeautify(customer.filter((res)=>res.customer_id==customer_id)[0].customer_loan)+"$":''}
                    >
                        <div className="flex-1 truncate">
                            {customer_id && customer_id!=0 ? 
                                <span className="text-gray-700">{customer.filter((res)=>res.customer_id==customer_id)[0].customer_name}</span> : 
                                <span className="text-gray-500">ناوی کڕیار</span>
                            }
                        </div>
                        <MdKeyboardArrowDown className={`text-gray-500 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
                    </div>
                    {isOpen && (
                        <div className="absolute w-full mt-2 bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-hidden z-10">
                            <div className="p-2 border-b border-gray-200">
                                <div className="relative">
                                    <MdSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                                    <input
                                        type="text"
                                        className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                        placeholder="بگەڕێ"
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        onClick={(e) => e.stopPropagation()}
                                    />
                                </div>
                            </div>
                            <div className="overflow-auto max-h-48">
                                <div
                                    className={"flex items-center p-3 hover:bg-gray-50 cursor-pointer border-b border-gray-100 last:border-b-0 transition-colors duration-150"}
                                    onClick={() => {
                                        setcustomer_id();
                                        setIsOpen(false);
                                        setSearchTerm("");
                                    }}
                                >
                                    <span className={"text-gray-500"}>ناوی کڕیار</span>
                                </div>
                                {filtereddoctor.length > 0 ? (
                                    filtereddoctor.map((option) => (
                                        <div
                                            key={option.customer_id}
                                            className={option.customer_id==1? "flex items-center p-3 bg-gray-200 hover:bg-gray-200 cursor-pointer border-b border-gray-100 last:border-b-0 transition-colors duration-150":"flex items-center p-3 hover:bg-gray-50 cursor-pointer border-b border-gray-100 last:border-b-0 transition-colors duration-150"}
                                            onClick={() => {
                                                if( option.customer_id==1) return;
                                                handlePresetClick(option)
                                            }}
                                        >
                                            <span className={option.customer_id==1?"text-gray-400":"text-gray-700 hover:text-gray-900"}>{option.customer_name}</span>
                                        </div>
                                    ))
                                ) : (
                                    <div className="p-3 text-center text-gray-500">
                                        هیچ کڕیارێک نەدۆزایەوە!
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
                <div className="w-full">
                    <label
                        className={
                            error
                            ? "block text-sm font-medium text-red-500 mb-1 text-right"
                            : "block text-sm font-medium text-slate-500 mb-1 text-right"
                        }
                        for="from"
                    >
                        لە بەرواری{" "}
                    </label>
                    <input
                        className={
                            error
                            ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                            : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                        }
                        id="from"
                        type="date"
                        value={from}
                        onChange={(val) => setfrom(val.target.value)}
                        onFocus={() => seterror(false)}
                    />
                </div>
                <div className="w-full">
                    <label
                        className={
                            error1
                            ? "block text-sm font-medium text-red-500 mb-1 text-right"
                            : "block text-sm font-medium text-slate-500 mb-1 text-right"
                        }
                        for="to"
                    >
                        بۆ بەرواری{" "}
                    </label>
                    <input
                        className={
                            error1
                            ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                            : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                        }
                        id="to"
                        type="date"
                        placeholder=""
                        value={to}
                        onChange={(val) => setto(val.target.value)}
                        onFocus={() => seterror1(false)}
                    />
                </div>
        </div>
      </div>
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4 sm:gap-6">
            {/* Add your existing report cards here with updated styling */}
            {/* Example of one card: */}
            <div
                className="cursor-pointer rounded-lg bg-white shadow-md 
                transition-all duration-200 hover:shadow-lg"
                onClick={()=>{
                    customerloanreportaction(customer_id)(initDispatch)(clear)(settable_type);
                }}
            >
                <div className="p-4 sm:p-6">
                <h5 className="mb-2 text-lg sm:text-xl font-medium text-gray-900">
                    لیستی قەرزی کڕیار
                </h5>
                <div className="pt-4 border-t text-sm text-gray-600">
                    -
                </div>
                </div>
            </div>
            <div
                className="cursor-pointer rounded-lg bg-white shadow-md 
                transition-all duration-200 hover:shadow-lg"
                onClick={()=>{
                    if(!from || from == "") {
                        seterror(true);
                        return false;
                    }
                    if(!to || to == "") {
                        seterror1(true);
                        return false;
                    }
                    customerloaninreportaction(from, to, customer_id)(initDispatch)(clear)(settable_type);
                }}
            >
                <div className="p-4 sm:p-6">
                <h5 className="mb-2 text-lg sm:text-xl font-medium text-gray-900">
                    لیستی قەرزی گەڕاوە
                </h5>
                <div className="pt-4 border-t text-sm text-gray-600">
                    لە بەرواری , بۆ بەرواری , کڕیار
                </div>
                </div>
            </div>
        </div>
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-1 gap-4 sm:gap-6">
            <div
                className="cursor-pointer rounded-lg bg-white shadow-md 
                transition-all duration-200 hover:shadow-lg"
                onClick={()=>{
                    summaryloaninreportaction()(initDispatch)(clear)(settable_type);
                }}
            >
                <div className="p-4 sm:p-6">
                <h5 className="mb-2 text-lg sm:text-xl font-medium text-gray-900">
                    پوختە
                </h5>
                <div className="pt-4 border-t text-sm text-gray-600">
                    -
                </div>
                </div>
            </div>
        </div>
        {table_type == "customer_loan_report"?<Customer_loan_table />:table_type == "loan_in_report"?<Loan_in_table />:table_type == "summary_loan_in_report"?<Summary_loan_in_table />:null}
    </div>
  )
}

export default Customer_Loan_Report